export default __webpack_public_path__ + "static/media/road-map-middle-1.a9afe65c.png";